import '../../App.css';

import { useQuery } from '@apollo/client';
import { Input, Pagination } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';

import { USERS_PER_PAGE } from '../../config/constants';
import { GET_ALL_USERS, GET_USERS_COUNT } from '../../graphql/queries';
import SearchIcon from '../Icons/Search';
import { roles } from '../state/atoms';
import UsersTable from '../Tables/UsersTable';
import H1 from '../Texts/H1';
// import NavigationCard from "../Cards/NavigationCard";
import H2 from '../Texts/H2';
import Paragraph from '../Texts/Paragraph';

export default function Users() {
  const [activePage, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const allRoles = useRecoilValue(roles);

  useEffect(() => {
    const timeoutId = window.setTimeout(() => {
      setDebouncedSearch(search.trim());
    }, 300);

    return () => window.clearTimeout(timeoutId);
  }, [search]);

  useEffect(() => {
    setPage(1);
  }, [debouncedSearch]);

  const { data: usersCountData, loading: loadingPagination } = useQuery(
    GET_USERS_COUNT,
    {
      variables: { search: debouncedSearch },
    }
  );

  const { data: usersData, loading: loadingUsers } = useQuery(GET_ALL_USERS, {
    notifyOnNetworkStatusChange: true,
    variables: {
      limit: USERS_PER_PAGE,
      offset: (activePage - 1) * USERS_PER_PAGE,
      search: debouncedSearch,
    },
  });

  const users = usersData?.users || [];
  const pageTotal = Math.max(
    1,
    Math.ceil((usersCountData?.usersCount || 0) / USERS_PER_PAGE)
  );

  const getRole = (role: string) => {
    if (roles) {
      const r = allRoles.find((ro: any) => ro.id === role);
      return r ? r.name : '-';
    }
    return '-';
  };

  return (
    <>
      <div className="flex justify-between">
        <div className="flex">
          <H2 text="Our" fontSize="32px" fontWeight={400} />
          <div className="pl-2">
            <H1 text="Users" fontSize="32px" />
          </div>
        </div>
      </div>
      <div className="pt-2">
        <Paragraph text="On this page you can compare your phone numbers with our database to find any DNC/TCPA numbers" />
      </div>
      <div className="pt-4 max-w-[360px]">
        <Input
          placeholder="Search users"
          radius="lg"
          value={search}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            setSearch(event.target.value)
          }
          rightSection={<SearchIcon />}
          styles={{
            input: {
              border: '1px solid #27ABE2',
            },
          }}
        />
      </div>
      <div className="pt-4">
        <UsersTable
          titleOptions={[
            { text: 'Full Name', fontSize: '14px' },
            { text: 'Email', fontSize: '14px' },
            { text: 'Role', fontSize: '14px' },
          ]}
          elements={
            users.length === 0
              ? []
              : users.map((u: any) => ({
                  email: u.email,
                  name: `${u.first_name} ${u.last_name || ''}`,
                  role: getRole(u.role),
                  id: u.id,
                }))
          }
          loading={loadingUsers}
        />
      </div>
      {!loadingPagination && users.length > 0 && (
        <div className="flex justify-center pt-5" style={{}}>
          <Pagination
            page={activePage}
            onChange={setPage}
            total={pageTotal}
            color="gray"
            size="sm"
            radius="md"
          />
        </div>
      )}
    </>
  );
}
